import CloseIcon from '@mui/icons-material/Close';
import { closeSnackbar } from 'notistack';
import type { CustomContentProps } from 'notistack';
import React from 'react';

import { SnackbarCloseButton, SnackbarMessage, SnackbarRoot } from './errorSnackbar.styles';

const ErrorSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, message }, ref) => {
    return (
      <SnackbarRoot ref={ref} elevation={6} role="alert">
        <SnackbarMessage variant="body2">{message}</SnackbarMessage>
        <SnackbarCloseButton size="small" aria-label="close" onClick={() => closeSnackbar(id)}>
          <CloseIcon fontSize="small" />
        </SnackbarCloseButton>
      </SnackbarRoot>
    );
  },
);

ErrorSnackbar.displayName = 'ErrorSnackbar';

export default ErrorSnackbar;
